import { Injectable } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormBuilder } from '@angular/forms';
import { FormInstrument } from '../shared/selected-instrument-toggler/form-instrument';
import { InstrumentDetailFullOut } from './rest-api/rest-api';

export interface StrategyFormInstrument {
  id: number,
  value: number,
  name: string,
  description: string,
  isin: string,
  instrumentCategory: string,
  rawInstrument: InstrumentDetailFullOut,
  cash?: boolean,
}

@Injectable({
  providedIn: 'root'
})
export class StrategyInstrumentsFormService {
  private _selectedInstruments: UntypedFormArray | null = null;
  private _strategyOriginalInstruments: UntypedFormArray | null = null;

  public get selectedInstruments(): UntypedFormArray | null {
    return this._selectedInstruments;
  }

  public set selectedInstruments(value: UntypedFormArray | null) {
    this._selectedInstruments = value;
  }

  public get strategyOriginalInstruments(): UntypedFormArray | null {
    return this._strategyOriginalInstruments;
  }

  public set strategyOriginalInstruments(value: UntypedFormArray | null) {
    this._strategyOriginalInstruments = value;
  }

  public constructor(
    private fb: UntypedFormBuilder,
  ) { }


  public getSelectedInstrumentById(searchedId: number): AbstractControl | null {
    if(this.selectedInstruments) {
      for (const instrumentControl of this.selectedInstruments.controls) {
        if (instrumentControl.value['id'] === searchedId) {
          return instrumentControl;
        }
      }
    }

    return null;
  }

  public removeSelectedInstrumentById(idToRemove: number): void {
    if(this.selectedInstruments) {
      this.selectedInstruments.removeAt(
        this.selectedInstruments.value.findIndex(
          (instrument: FormInstrument) => instrument.id === idToRemove
        )
      );
    }
  }

  public addInstrumentControl(instrument: InstrumentDetailFullOut): void {
    const newInstrument = this.fb.group({
      id: instrument.instrumentId,
      value: 0,
      name: instrument.name,
      description: instrument.description,
      humanName: instrument.humanName,
      isin: instrument.isin,
      instrumentCategory: instrument.instrumentCategory,
      regionalOrientations: instrument.regionalOrientations,
      rawInstrument: instrument, //todo - full type?
      rebalancedMonthly: instrument.rebalancedMonthly,
    });

    this.selectedInstruments?.push(newInstrument);
  }
}
